import { ListManagerFrontendError } from './ListManagerFrontendError';

// Superclass for errors involving message passing with rocket iframe
export class RocketIntegrationError extends ListManagerFrontendError {
  static errorName = 'RocketIntegrationError';
}
